import { OutputTypeEnum } from "../types/outputDestinationsTypes";

export const getOutputTypeName = (type: number): string => {
  switch (type) {
    case OutputTypeEnum.ARCHIVE:
      return "Archive";
    case OutputTypeEnum.BACKUP:
      return "Backup";
    default:
      return "Unknown";
  }
};
